import styled from 'styled-components'
import media from 'styled-media-query'

export const InitialPageStyled = styled.div`
  //
  ${media.lessThan('medium')`
    order: 4;
  `}
  
  & button {
    padding: 5px 6px 6px;

    ${media.lessThan('medium')`
      width: 100%;
    `}
  }
`
